module.exports = __webpack_public_path__ + "Tinebase/js/ace-json5-FAT.js";